export default __webpack_public_path__ + "empty-testimonials-illustration.8ae9aba7.png";